export interface QuestionType {
  id?: string;
  dataType: 'number' | 'text' | 'date' | 'file' | 'boolean';
  regex?: string;
  label: string;
  enabled: boolean;
}

export const DATA_TYPE_OPTIONS = [
  { value: 'number', label: 'Números' },
  { value: 'text', label: 'Comentarios' },
  { value: 'date', label: 'Fecha' },
  { value: 'file', label: 'Archivo' },
  { value: 'boolean', label: 'Si/No' },
];

/** Obtiene los tipos de pregunta habilitados del módulo. */
export function getTypeOptions(module: any): QuestionType[] {
  const types = module?.questionTypes;
  return Array.isArray(types) ? types.filter(t => t.enabled) : [];
}

/** Resuelve el modo de meses del sistema. */
export function getSystemMonths(module: any): 'all' | 'selectable' {
  return module?.evaluateAllMonths ? 'all' : 'selectable';
}
